/**
 * Dropdown component renders a customizable dropdown menu.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.selectedOption - The currently selected option.
 * @param {function} props.handleChange - The function to handle the change event.
 * @param {Array} props.options - The array of options to display in the dropdown.
 * @param {string} props.name - The label for the dropdown.
 * @param {string} props.className - Additional class names for the select element.
 */

import React from 'react'
import Select from 'react-select'

export default function SearchableDropdown({ className ,selectedOption, noOptionsAvailable,onChange, options, name ,placeholder,isDisabled, isMulti = false,}) {


    const allOptions = options.map((option) => {
        return { value: option, label: option }
    })
    const selectedOptionForDropdown = isMulti
    ? selectedOption?.map((opt) => ({ value: opt, label: opt })) // Convert array of selected options for multi-select
    : selectedOption
    ? { value: selectedOption, label: selectedOption } // Single select
    : null;
    

    return (
        <>
            <div className= {`d-flex flex-column`} style={{zIndex: 120}}>
                <p style={{ marginBottom: '3px', marginTop: '15px' }}>{name}</p>
                <Select
                    className = {className}
                    style={{height: '20px'}}
                    options={allOptions}
                    value={selectedOptionForDropdown}
                    placeholder={placeholder}
                    onChange={onChange}
                    noOptionsMessage={() => noOptionsAvailable}
                    isDisabled={isDisabled}
                    isMulti={isMulti}
                />
            </div>
        </>
    )
}


